<template>
  <div v-title="$route.meta.title">
    <div class="page-heading">
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
        <el-breadcrumb-item :to="`/${routerPath}/table`">回款列表</el-breadcrumb-item>
        <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <template v-if="showErrorMsg">
      <error-panel v-if="detailErrorMsg" :message="detailErrorMsg" show-back/>
    </template>
    <template v-else>
    <layout-panel>
      <span slot="header">新增回款</span>
      <el-form ref="form"
               :model="form"
               :rules="formRules"
               size="medium"
               label-width="140px"
               @submit.native.prevent="onSubmit()">
        <div class="re-el-form__flex">
          <div class="large">
            <el-form-item label="客户名称"
                          prop="customerid">
              <remote-select
                class="width-max"
                clearable
                id-key="number"
                label-key="name"
                value-key="id"
                placeholder="请输入客户名称/编号搜索"
                v-model="form.customerid"
                @change="onChangeCustomerId"
                :query-request="(_)=>getCustomerTable(Object.assign(_, {type: 'all'}))"
                :find-request="getCustomerDetail">
              </remote-select>
            </el-form-item>
            <el-form-item label="抬头" prop="receipt_info_id">
              <el-select v-model="form.receipt_info_id"
                         class="width-max"
                         clearable
                         placeholder="请选择">
                <el-option
                  v-for="item in receiptOptions"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="" prop="null" v-if="showReceiptErr">
              <span style="color:red">当前客户下未找到此 id 对应的客户开票抬头信息，抬头数据已重置</span>
            </el-form-item>
            <el-form-item>
              <div class="receipt-info-block">
                <h3>客户开票信息</h3>
                <span class="receipt-info"><span class="receipt-info-text">公司名称: </span>{{receiptInfo.company_name}}
                  </span>
                <span class="receipt-info"><span class="receipt-info-text">开户行及账号: </span>{{receiptInfo.bank_info}}
                  </span>
                <span class="receipt-info"><span class="receipt-info-text">地址及电话: </span>{{receiptInfo.address_phone}}
                </span>
                <span class="receipt-info"><span class="receipt-info-text">税号: </span>{{receiptInfo.tax_number}}
                </span>
              </div>
            </el-form-item>
            <el-form-item label="回款描述"
                          prop="desc">
              <el-input v-model="form.desc" placeholder="请输入回款描述"></el-input>
            </el-form-item>
            <el-form-item label="回款类型"
                          prop="type">
              <el-select v-model="form.type"
                         class="width-max">
                <el-option
                  v-for="(label, value) in collectionTypeText"
                  :key="value"
                  :label="label"
                  :value="value">
                </el-option>
              </el-select>
            </el-form-item>

            <el-form-item label="收款公司"
                          prop="our_company_id">
              <el-select v-model="form.our_company_id"
                         class="width-max"
                         @change="changeOurComId">
                <el-option
                  v-for="item in activeMineManagedCompanies"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id">
                </el-option>
              </el-select>
              <div v-if="companyErrorMessage"
                   style="color: #f56c6c; font-size: 12px; line-height: 1; padding-top: 4px;">
                {{ companyErrorMessage }}
              </div>
            </el-form-item>
            <el-form-item label="收款账户"
                          prop="our_company_account_id">
              <remote-select
                class="width-max"
                clearable
                id-key="id"
                keyword-key="name"
                label-key="name"
                value-key="id"
                :disabled="!form.our_company_id"
                placeholder="请选择收款账户"
                v-model="form.our_company_account_id"
                :query-params="{ our_company_id: form.our_company_id, is_disabled: 0 }"
                :query-request="getCompanyAccountManagementTable"
                :find-request="getCompanyAccountManagementDetail">
              </remote-select>
            </el-form-item>
            <el-form-item label="回款金额"
                          prop="collection_amount">
              <el-input v-model="form.collection_amount" placeholder="请输入回款金额"></el-input>
            </el-form-item>
            <el-form-item label="回款日期"
                          prop="received_date">
              <el-date-picker
                class="width-max"
                v-model="form.received_date"
                value-format="yyyy-MM-dd"
                :picker-options="dateTimePickerRangeOptions"
                type="date"
                placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="收件人" prop="mail_to">
              <remote-select
                class="width-max"
                clearable
                multiple
                id-key="id"
                keyword-key="name"
                label-key="name"
                value-key="id"
                placeholder="请输入管理员名称搜索"
                v-model="form.mail_to"
                :query-request="(_)=>getPlatformUsersIndex(Object.assign(_, {usertype: [1, 2, 3, 4, 5], status: 1}))"
                :find-request="getPlatformUsersDetail">
              </remote-select>
            </el-form-item>
            <el-form-item label="回款备注"
                          prop="memo">
              <el-input v-model="form.memo" placeholder="请输入回款备注"></el-input>
            </el-form-item>
            <el-form-item label="附件"
                      prop="attached_file">
              <el-upload
                class="upload-demo"
                action=""
                :auto-upload="false"
                :on-change="(file, fileList) => {onChangeFile(file, fileList, this.form.attached_file)}"
                :before-remove="(file, fileList) => {beforeRemove(file, fileList, this.form.attached_file)}"
                multiple
                :limit="20"
                :on-exceed="(file, fileList) => {handleExceed(file, fileList, 20)}"
                :file-list="fileList"
                ref="upload"
                accept=".jpg, .jpeg, .png, .pdf, .eml, .html, .htm, .xls, .xlsx, .doc, .docx, .zip"
                >
                <el-tooltip class="item" effect="dark" content="点击上传附件" placement="right">
                <el-button size="small"
                           :loading="loadingFileUpload"
                            type="primary">点击上传
                </el-button>
                </el-tooltip>
                <div slot="tip"
                      class="el-upload__tip">请上传PNG/JPG/PDF/EML/HTML/WORD/EXCEL/ZIP文件，仅支持上传20个文件，20以上建议上传zip格式
                </div>
              </el-upload>
            </el-form-item>
          </div>
        </div>
        <el-form-item>
          <el-button @click="$router.back()">返回</el-button>
          <el-button type="primary"
                     :disabled="loadingFileUpload"
                     native-type="submit">保存
          </el-button>
        </el-form-item>
      </el-form>
    </layout-panel>
    </template>
  </div>
</template>

<script>
import { formRules } from '../received-payment.rules.js'
import ErrorPanel from '@components/ErrorPanel.vue'

export default {
  components: {
    ErrorPanel,
  },
  data () {
    return {
      id: 0,
      formRules,
      showErrorMsg: false,
      detailErrorMsg: '',
      receiptOptions: [],
      form: {
        customerid: '',
        receipt_info_id: null,
        desc: '',
        type: '',
        our_company_id: '',
        our_company_account_id: null,
        collection_amount: '',
        received_date: '',
        mail_to: [],
        memo: '',
        attached_file: [],
      },
      receiptInfo: {},
      allMineManagedCompanies: [],
      activeMineManagedCompanies: [],
      showReceiptErr: false,
      companyErrorMessage: '',
      fileList: [],
      loadingFileUpload: false,
      dateTimePickerRangeOptions: {
        disabledDate: function (time) {
          return time.getTime() > Date.now()
        },
      },
    }
  },
  computed: {
    ...Vuex.mapState({
      collectionTypeText: state => state.receivedPayment.collectionTypeText,
      user: state => state.login.user,
    }),

    routerPath () {
      return `received-${this.$route.meta.type}`
    },
  },
  watch: {
    'form.receipt_info_id': function (newValue, oldValue) {
      // 判断 receipt_info_id 是否发生了变化，减少对接口无意义的调用
      if (this.form.receipt_info_id > 0 && newValue * 1 !== oldValue * 1) {
        this.setCurrentReceiptInfo()
      }
    },
  },
  async created () {
    await this.setMineCompanies()
    if (this.showErrorMsg) return

    this.id = this.$route.params.id || 0
    this.id > 0 && this.setDetailData(this.id)
  },
  mounted () {},
  methods: {
    ...request.map([
      'getCustomerReceiptDetail',
      'getCompanyAccountManagementTable',
      'getCompanyAccountManagementDetail'
    ]),
    ...Vuex.mapActions([
      'getCustomerTable',
      'getCustomerDetail',
      'getPlatformUsersIndex',
      'getPlatformUsersDetail',
    ]),
    getForm () {
      return filter.copyJson(this.form)
    },
    onSubmit () {
      this.$refs['form'].validate((valid) => {
        if (valid) {
          this.id ? this.update(this.id) : this.create()
        } else {
          this.$message.error('提交内容填写不正确！')
        }
      })
    },
    create () {
      request.common('createReceivedPaymentData', this.getForm()).then((res) => {
        this.$confirm(this.$route.meta.title + '成功, 是否继续添加？', '提示', {type: 'success'}).then(() => {
          Object.assign(this.$data.form, this.$options.data.call(this).form)
          this.$refs.form.resetFields()
          this.$refs.upload.clearFiles()
        }, () => {
          this.goApproveTable()
        })
      })
    },
    update (id) {
      request.common('updateReceivedPaymentData', {id, ...this.getForm()}).then((res) => {
        this.$confirm('数据修改成功，请同步更新金蝶中的收款单数据', '提示', {type: 'success'}).then(() => {
          this.goApproveTable()
        })
      })
    },
    goApproveTable () {
      this.$router.push({path: '/received-approval/table/'})
    },
    onChangeCustomerId () {
      this.receiptOptions = []
      if (this.form.customerid > 0) {
        let id = this.form.customerid
        request.page('getCustomerReceiptOptions', {customerid: id}).then(({data}) => {
          this.receiptOptions = data
          this.resetReceiptInfo()
        })
      } else {
        this.resetReceiptInfo()
      }
    },
    async setMineCompanies () {
      // 超管可以修改/创建所有活跃状态公司的回款单
      if (this.user.usertype * 1 === 1) {
        await request('getFinCenterConfigs').then(({data}) => {
          this.setupMineCompanyList(data.payment_apply_our_company_source)
        }).catch((e) => {
          this.detailErrorMsg = String(e).replace(/^Error:\s*/i, '')
          this.showErrorMsg = true
        })
      } else {
        await request('getMineManagedCompaniesApi').then(({data}) => {
          this.setupMineCompanyList(data)
        }).catch((e) => {
          this.detailErrorMsg = String(e).replace(/^Error:\s*/i, '')
          this.showErrorMsg = true
        })
      }
    },
    setupMineCompanyList (data) {
      this.allMineManagedCompanies = data.map(item => {
        item.id = item.id * 1
        return item
      })
      this.activeMineManagedCompanies = this.allMineManagedCompanies.filter(company => company.is_disabled === 0)
      if (this.activeMineManagedCompanies.length > 0) {
        this.showErrorMsg = false
      } else {
        this.detailErrorMsg = '您所负责的公司列表为空,或已负责的公司均被禁用,请联系超管分配可用的负责公司'
        this.showErrorMsg = true
      }
    },
    resetReceiptInfo () {
      this.form.receipt_info_id = null
      this.receiptInfo = {
        customerid: null,
        company_name: null,
        tax_number: null,
        bank_info: null,
        address_phone: null,
      }
    },
    setCurrentReceiptInfo () {
      if (this.form.customerid > 0) {
        let id = this.form.customerid
        this.showReceiptErr = false
        request.page('getCustomerReceiptOptions', {customerid: id}).then(({data}) => {
          this.receiptOptions = data

          let findSuccess = false
          for (const dataKey in data) {
            if (data[dataKey].id === this.form.receipt_info_id) {
              this.receiptInfo = _.cloneDeep(data[dataKey])
              findSuccess = true
            }
          }
          if (!findSuccess && this.form.receipt_info_id > 0) {
            this.resetReceiptInfo()
            this.showReceiptErr = true
          }
        })
      } else {
        this.resetReceiptInfo()
      }
    },
    handleExceed (files, fileList, max) {
      this.$message.warning(`当前限制选择 ${max} 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`)
    },
    beforeRemove (file, fileList, formField) {
      let fileTemp
      if (file.raw) {
        fileTemp = file.raw
      } else {
        fileTemp = file
      }
      let index = this.getFileListIndex(fileTemp, fileList)
      if (index > -1) {
        formField.splice(index, 1)
      }
    },
    getFileListIndex (file, fileList) {
      for (let i = 0; i < fileList.length; i++) {
        let fileTemp
        if (fileList[i].raw) {
          fileTemp = fileList[i].raw
        } else {
          fileTemp = fileList[i]
        }
        if (file === fileTemp) {
          return i
        }
      }
      return -1
    },
    onChangeFile (file, fileList, formField) {
      let isLt5M = file.raw.size / 1024 / 1024 < 50
      if (!isLt5M) {
        this.$message.error('文件内容必须小于50MB!')
        this.$refs.upload.uploadFiles.pop()
        return false
      }
      this.onUploadFile(file.raw, fileList, formField)
    },
    onUploadFile (file, fileList, formField) {
      this.loadingFileUpload = true

      let formData = new FormData()
      formData.append('file', file)
      this.id && formData.append('apply_id', this.id)
      return request.alert('finCenterUploadPaymentApplyFile', formData).then(({data}) => {
        this.$message({
          showClose: true,
          message: '上传成功',
          type: 'success',
        })
        let index = this.getFileListIndex(file, fileList)

        let type = file.name.split('.').pop().toLowerCase()
        if (['jpeg', 'jpg', 'png'].includes(type)) {
          type = 'pic'
        } else if (['pdf'].includes(type)) {
          type = 'pdf'
        } else if (['eml', 'html', 'htm'].includes(type)) {
          type = 'eml'
        } else if (['xlsx', 'doc', 'docx'].includes(type)) {
          type = 'office'
        } else if (['zip'].includes(type)) {
          type = 'zip'
        }
        if (index > -1) {
          formField[index] = {name: file.name, url: data, type: type}
        }
        this.loadingFileUpload = false
      }).catch(_ => {
        this.$refs.upload.uploadFiles.pop()
        this.loadingFileUpload = false
      })
    },
    changeOurComId () {
      this.form.our_company_account_id = null
      this.companyErrorMessage = ''
    },
    isFinancePage () {
      return this.$route.meta.type === 'approval'
    },
    setDetailData (id) {
      const params = {
        id,
        forFinance: this.isFinancePage() ? 1 : 0
      }
      request('getNewReceivedPaymentDetail', params).then(({data}) => {
        this.form = _.cloneDeep(data)
        const usedComName = _.get(this.form, 'our_company.name', '')
        const isValidCompany = this.allMineManagedCompanies.find(company => company.id === this.form.our_company_id)
        if (!isValidCompany) {
          this.form.our_company_id = null
          this.companyErrorMessage = `所选收款公司【${usedComName}】不在您的负责范围内，请重新选择`
        } else {
          if (isValidCompany.is_disabled) {
            this.form.our_company_id = null
            this.companyErrorMessage = `所选收款公司【${usedComName}】已被禁用，请重新选择`
          } else {
            this.companyErrorMessage = ''
          }
        }
        this.form.customerid = data.customerid > 0 ? data.customerid + '' : null
        this.form.type = this.form.type + ''
        this.fileList = data.attached_file
        this.setCurrentReceiptInfo()
        this.showErrorMsg = false
      }).catch((e) => {
        this.detailErrorMsg = String(e).replace(/^Error:\s*/i, '')
        this.showErrorMsg = true
      })
    },
  },
}
</script>
<style lang="scss">
// 全局CSS
</style>
<style lang="scss"
       scoped>

.receipt-info {
  display: block;
  margin-bottom: 5px;
}

.receipt-info-text {
  font-weight: bold
}
.receipt-info-block {
  width: 470px;
  // margin-bottom: 30px;
  // margin-left: 70px;
  border-radius:5px;
  border: 2px solid transparent;
  background-clip: padding-box;
  background-color: rgba(128, 128, 128, 0.1);
  padding: 5px 10px;
}
// 带作用域的CSS
// https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
</style>
<style lang="scss"
       module>
// 带作用域的CSS
// 绑定class方式 <p :class="$style.red"></p>
// https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
</style>



// WEBPACK FOOTER //
// src/views/received-payment/pages/ReceivedPaymentForm.vue